module.exports = __webpack_public_path__ + "static/media/dhannashri-bhandari.1e2ace28.jpg";